<template>
  <div>
    <v-container class="py-12">
      <v-card elevation="6" rounded="xl" class="pa-6">
        <v-card-title class="text-h4 font-weight-bold mb-4">
          Privacy Policy
        </v-card-title>
        <v-card-text class="text-body-1">
          <!-- Loading State -->
          <div v-if="isLoading" class="text-center py-8">
            <v-progress-circular
              indeterminate
              color="primary"
              size="50"
            ></v-progress-circular>
            <p class="mt-4">Loading Privacy Policy...</p>
          </div>

          <!-- Content from API -->
          <div
            v-else-if="companyData && companyData.privacy_policy"
            v-html="companyData.privacy_policy"
            class="privacy-content"
          ></div>

          <!-- Fallback if no content -->
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
            <p class="mt-4 grey--text">Privacy Policy content is not available.</p>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PrivacyPolicy",
  data() {
    return {
      companyData: null,
      isLoading: false,
    };
  },
  mounted() {
    this.getCompanyData();
  },
  methods: {
    async getCompanyData() {
      this.isLoading = true;
      try {
        const companyId = this.company?.id || this.user?.companies?.[0]?.id;
        if (companyId) {
          const response = await axios.get(`/companies/${this.encryptIt(companyId)}`);
          this.companyData = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.privacy-content {
  line-height: 1.8;
}

.privacy-content >>> h1,
.privacy-content >>> h2,
.privacy-content >>> h3,
.privacy-content >>> h4,
.privacy-content >>> h5,
.privacy-content >>> h6 {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-weight: bold;
}

.privacy-content >>> p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.privacy-content >>> ul,
.privacy-content >>> ol {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.privacy-content >>> li {
  margin-bottom: 0.5rem;
}

.privacy-content >>> a {
  color: #1976d2;
  text-decoration: none;
}

.privacy-content >>> a:hover {
  text-decoration: underline;
}
</style>
